































import { defineComponent } from '@vue/composition-api';
import type { PropType } from 'vue';

export default defineComponent({
  name: 'SearchLayout',
  props: {
    placement: {
      type: String,
      default: 'bottom-start',
    },
    offset: {
      type: Array as PropType<number[]>,
      default: () => [0, 0],
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },
  setup(_, { emit }) {
    const show = () => {
      emit('open');
    };

    const hide = () => {
      emit('close');
    };

    return {
      show,
      hide,
    };
  },
});
